import ImageCompare from 'image-compare-viewer';
export default {
  init() {
    // JavaScript to be fired on pages that use the Content Image Comparison Layout
    const element = document.getElementById('image-compare');

    new ImageCompare(element).mount();
  },
  finalize() {
    // JavaScript to be fired on pages that use the Content Image Comparison Layout, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/imageComparison.js